import React from "react";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
const StyledList = styled.ul`
  padding: 0;
  margin: 0;
`;
const EntityList = ({ bsNoItemsStyle = void 0, items, noItemsText = "No items available" }) => {
  if (items.length === 0) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: bsNoItemsStyle }, noItemsText);
  }
  return /* @__PURE__ */ React.createElement(StyledList, null, items);
};
export default EntityList;
